export default __webpack_public_path__ + "static/media/desktop-step4a.b78a92d5.png";